module.exports = __webpack_public_path__ + "img/d06-min.8a049b52.png";